import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { PageRenderer } from '@/components/PageRenderer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const DynamicPage = ({ slug: propSlug }) => {
  const { slug: paramSlug } = useParams();
  const slug = propSlug || paramSlug;
  
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API}/pages/${slug}`);
        setPage(response.data);
        setError(null);
      } catch (err) {
        console.error('Failed to load page:', err);
        setError('Page not found');
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchPage();
    }
  }, [slug]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (error || !page) {
    return null; // Let the original page content show
  }

  // If page has blocks, render them
  if (page.blocks && page.blocks.length > 0) {
    return <PageRenderer blocks={page.blocks} />;
  }

  // No blocks, return null to show original content
  return null;
};

export default DynamicPage;
